var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gwnl-eval-evaluator__row" },
    [
      _c(
        "yxt-tooltip",
        {
          attrs: {
            content: _vm.evaluatorLevel,
            placement: "top",
            "open-filter": "",
          },
        },
        [
          _c(
            "span",
            {
              staticClass:
                "color-gray-7 lh-50 mr24 yxtbiz-flex-shrink-0 ellipsis max-width-100",
            },
            [_vm._v(_vm._s(_vm.evaluatorLevel))]
          ),
        ]
      ),
      _vm.showWeight
        ? _c(
            "span",
            {
              staticClass:
                "color-gray-10 lh-50 mr24 yxtbiz-flex-shrink-0 min-width30",
            },
            [_vm._v("\n    " + _vm._s(_vm.relation.weight + "%") + "\n  ")]
          )
        : _vm._e(),
      _c(
        "yxt-button",
        {
          staticClass: "mr16 shrink0",
          attrs: { plain: "", disabled: _vm.row.selectDisable || false },
          on: { click: _vm.selectPersonnel },
        },
        [
          _vm._v(
            "\n    " + _vm._s(_vm.$t("pc_gwnl_eval_selectPersonnel")) + "\n  "
          ),
        ]
      ),
      !_vm.validate && _vm.validateError
        ? _c("span", { staticClass: "color-fa5252 font-size-12 lh-50" }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("pc_gwnl_eval_pleaseSelectPersonnel")) +
                "\n  "
            ),
          ])
        : _vm._e(),
      _vm.relation.evaluators.length > 0
        ? _c(
            "div",
            { staticClass: "mt8 lh-normal" },
            [
              _vm._l(_vm.evaluatorDisplay, function (tag) {
                return _c(
                  "yxt-tag",
                  {
                    key: tag.id,
                    staticClass: "mr8 mb8",
                    attrs: {
                      size: "small",
                      type: "info",
                      closable: !_vm.row.selectDisable,
                    },
                    on: {
                      close: function ($event) {
                        return _vm.deleteEvaluator(tag)
                      },
                    },
                  },
                  [
                    _c(
                      "yxt-popover",
                      {
                        attrs: {
                          placement: "top",
                          trigger: "hover",
                          "max-width": 300,
                          "open-filter": true,
                          content: tag.fullname,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "yxtbiz-user-selector-tag max-width-62",
                            attrs: { slot: "reference" },
                            slot: "reference",
                          },
                          [
                            _c("yxtbiz-user-name", {
                              attrs: { name: tag.fullname || tag.fullName },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                )
              }),
              _c(
                "yxt-tag",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.relation.evaluators.length > 20,
                      expression: "relation.evaluators.length>20",
                    },
                  ],
                  staticClass: "mr8 mb8 hand",
                  attrs: { size: "small", type: "info" },
                  on: { click: _vm.handleExpandTag },
                },
                [
                  _c("span", { staticClass: "mr8" }, [
                    _vm._v(
                      _vm._s(
                        _vm.toExpand
                          ? _vm.$t("pc_eval_web_up_more" /*展开更多*/)
                          : _vm.$t("pc_gwnl_clamp_retract" /*收起*/)
                      )
                    ),
                  ]),
                  _c("i", {
                    class: _vm.toExpand
                      ? "yxt-icon-arrow-down"
                      : "yxt-icon-arrow-up",
                  }),
                ]
              ),
              _vm.relation.evaluators.length > 200
                ? _c(
                    "div",
                    { staticClass: "color-fa5252 font-size-12 lh-50" },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.$t(
                              "pc_eval_uptoMaxAddPerson",
                              [200] /*最多可添加200个评估人*/
                            )
                          ) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _c(
        "yxtbiz-eval-select-user",
        {
          ref: "selector",
          attrs: {
            visible: _vm.dialogVisible,
            "function-code": _vm.functionCode,
            data: _vm.evaluators,
            "data-permission-code": _vm.dataPermissionCode,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            getUsers: _vm.getUsers,
          },
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("pc_gwnl_eval_btn_addTesters")))]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }